import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/_services/generic.service';
import { environment } from "environments/environment";
import { DossierNoteModel } from './models/dossier-note.model';
@Injectable({
    providedIn: 'root',
})

export class NoteTypeService extends GenericService<DossierNoteModel> {
    rootApiUrl: string = environment.Services.AlphaURLSlot1;
    constructor(private http: HttpClient) {
        super(http,'/NoteType/', environment.Services.AlphaURLSlot1)
    }

    private generateHeaders() {
        return {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          }),
        };
      }

     GetNoteTypeListByRole(AuthorizationGroupRoleId) {
        return this.http.post(
          this.rootUrl + "/NoteType/GetNoteTypeListByRole/" , AuthorizationGroupRoleId,
          this.generateHeaders()
        ); 
      } 
}